import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Override14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_163)'>
      <path
        d='M5.46973 3.5303L8.18939 6.24997L1 6.24997L1 7.74997L8.1894 7.74997L5.46973 10.4696L6.53039 11.5303L11.0607 6.99997L6.53039 2.46964L5.46973 3.5303Z'
        fill='currentColor'
      />
      <path
        d='M12.25 1.99997V12H13.75V1.99997L12.25 1.99997Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_163'>
        <rect
          width='14'
          height='14'
          fill='white'
          transform='translate(0 14) rotate(-90)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Override14.displayName = 'Override14';
export default Override14;
